// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2Ufjd","header":"ClearentDisclaimer_header__VXkb6","inner":"ClearentDisclaimer_inner__XVhGy"};